var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pfol row" },
    [
      _c("div", { staticClass: "pfol__header small-12" }, [
        _vm._v("\n    " + _vm._s(_vm.$t("tenantProjects.comments")) + "\n  "),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "small-12" }, [
        _c(
          "div",
          { staticClass: "pfol__body" },
          [
            _vm.hasUnderReviewPostFitout
              ? [
                  _c(
                    "div",
                    {
                      staticClass: "pfol__title-box",
                      class: [_vm.isOverTwoText ? "align-top" : "align-middle"],
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "pfol__title align-middle" },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.underReviewTitle) +
                              "\n            "
                          ),
                          _vm.showCancelMenu
                            ? _c(
                                "DottedMenu",
                                {
                                  ref: "cancelDottedMenu",
                                  attrs: {
                                    enableClickOutClose: true,
                                    color: "darkblue",
                                  },
                                },
                                [
                                  _c("HKLButton", {
                                    attrs: { action: "cancel" },
                                    on: { click: _vm.openCancelModal },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "tip" },
                        _vm._l(_vm.textHistories, function (item, index) {
                          return _c("HKLGrayHint", { key: index }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(item) +
                                "\n            "
                            ),
                          ])
                        }),
                        1
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "pfol__content-box row" },
                    [
                      _vm.shouldShowDescription
                        ? [
                            _c(
                              "div",
                              { staticClass: "pfol__description-box small-12" },
                              [
                                _vm.allowedEditingWithPaneActivated
                                  ? _c("DescriptionTinymceEditor", {
                                      model: {
                                        value: _vm.openingDescription,
                                        callback: function ($$v) {
                                          _vm.openingDescription = $$v
                                        },
                                        expression: "openingDescription",
                                      },
                                    })
                                  : _c("p", {
                                      staticClass: "pfol__description-readonly",
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.openingDescription
                                        ),
                                      },
                                    }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "pfol__description-box small-12" },
                              [
                                _vm.allowedEditingWithPaneActivated
                                  ? _c("DescriptionTinymceEditor", {
                                      attrs: { height: 150 },
                                      model: {
                                        value: _vm.description,
                                        callback: function ($$v) {
                                          _vm.description = $$v
                                        },
                                        expression: "description",
                                      },
                                    })
                                  : _c("p", {
                                      staticClass: "pfol__description-readonly",
                                      domProps: {
                                        innerHTML: _vm._s(_vm.description),
                                      },
                                    }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("PostFitOutGuidelineComment", {
                              ref: "refPostFitOutGuidelines",
                              staticClass: "pfol__guide-comment",
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "pfol__description-box small-12" },
                              [
                                _vm.allowedEditingWithPaneActivated
                                  ? _c("DescriptionTinymceEditor", {
                                      model: {
                                        value: _vm.closingDescription,
                                        callback: function ($$v) {
                                          _vm.closingDescription = $$v
                                        },
                                        expression: "closingDescription",
                                      },
                                    })
                                  : _c("p", {
                                      staticClass: "pfol__description-readonly",
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.closingDescription
                                        ),
                                      },
                                    }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "pfol__attachments small-12" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "row" },
                                  [
                                    _vm.curReviewerWithAccess
                                      ? _c("HkldDropzone", {
                                          staticClass: "small-12",
                                          attrs: {
                                            sourceId: _vm.currentSubmission.id,
                                          },
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c("TenantSubmissionDocuments", {
                                      staticClass: "small-12",
                                      attrs: {
                                        canEdit: _vm.curReviewerWithAccess,
                                        sourceId: _vm.currentSubmission.id,
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            ),
                          ]
                        : _c(
                            "div",
                            { staticClass: "small-12 tip under-review__tip" },
                            [
                              _c("div", { staticClass: "tip__text" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.underReviewText) +
                                    "\n            "
                                ),
                              ]),
                            ]
                          ),
                    ],
                    2
                  ),
                ]
              : _vm._e(),
            _vm._v(" "),
            _c("PostFitOutHistory"),
          ],
          2
        ),
      ]),
      _vm._v(" "),
      _c("HKLModal", {
        ref: "cancelModalRef",
        attrs: {
          okBtnAction: "yes",
          cancelBtnAction: "no",
          title: _vm.$t("tenantProjects.postFitout.cancelMsg"),
        },
        on: { onOkClick: _vm.cancel },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }